import { Stack } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { useEffect, useState } from "react";
import { StakingAnalytics } from "src/components/StakingAnalytics";
import { StakingCommunity } from "src/components/StakingCommunity";
import { StakingIntro } from "src/components/StakingIntro";
import { StakingPools } from "src/components/StakingPools";
import { StakingSecurity } from "src/components/StakingSecurity";
import { StakingWetezBenefits } from "src/components/StakingWetezBenefits";
import { useStakingInfo } from "src/hooks/useStakingInfo";
import { ProviderItems, StakingPoolItemModel } from "src/models/StakingPool";
import { Provider } from "src/components/Provider";
import linkIcon from "src/assets/images/icon_link.svg";
import connextIcon from "src/assets/images/icon_connext.svg";
import EthereumIcon from "src/assets/images/icon_ethereum.svg";
import CosmosIcon from "src/assets/images/icon_cosmos.svg";
import fortaIcon from "src/assets/images/icon_forta.png";
import evmosIcon from "src/assets/images/icon_evmos2.svg";
import junoIcon from "src/assets/images/icon_juno.svg";
import hscIcon from "src/assets/images/icon_hsc.svg";
import SolanaIcon from "src/assets/images/icon_solana.svg";
import AstarIcon from "src/assets/images/icon_astar.svg";
import theGraphIcon from "src/assets/images/icon_theGraph.svg";
import MaticIcon from "src/assets/images/icon_matic.svg";
import ArbitrumIcon from 'src/assets/images/icon_arbitrum.svg';
import CircularProgress from "@material-ui/core/CircularProgress";
import IPFSIcon from "src/assets/images/icon_IPFS.svg";
import CeramicIcon from "src/assets/images/icon_ceramic.png";
import icon_GravityBridge from "src/assets/images/icon_GravityBridge.png";
import icon_Okchain from "src/assets/images/icon_Okchain.svg";
// import { Banner } from 'src/components/Banner';
import { Web3ToolBuilder } from "src/components/Web3ToolBuilder"


const infrastructureProviderDatas: ProviderItems[] = [{
  nodeName: "Chainlink",
  subTitle: "Data Provider",
  buttonText: "Details",
  url: "https://market.link/nodes/d018f48c-2412-44f5-bf02-76394b454875/feeds",
  icon: linkIcon
}, {
  nodeName: "Connext",
  subTitle: "Liquidity Provider",
  buttonText: "Details",
  url: "https://connextscan.io/router/0xfbf8b0394c5936a18731ea7086b19856ddad1023",
  icon: connextIcon
}, {
  nodeName: "Astar",
  subTitle: "Collator",
  buttonText: "Details",
  url: "https://astar.subscan.io/account/aCjn9DDdCqGredzxPjpRxabveyPUBJgP5cB3GLC3WBxg3rf?tab=transfer",
  icon: AstarIcon
}
  // , {
  //   nodeName: "IPFS",
  //   subTitle: "Gateway",
  //   buttonText: "Details",
  //   type: "Soon",
  //   url: "https://ipfs.wetez.io/",
  //   showModal: true,
  //   icon: IPFSIcon,
  //   modalTitle: "IPFS Public Gateway",
  //   describe: "IPFS gateway resolves access to any requested IPFS content identifier."
  // }
  , {
  nodeName: "The Graph",
  subTitle: "Indexer",
  buttonText: "Details",
  url: "https://thegraph.com/explorer/profile?id=0x376ca6892ab19bfd90515257b5f6b31561c300aa&view=Indexing",
  icon: theGraphIcon
}
  , {
  nodeName: "Forta",
  subTitle: "Scanner",
  buttonText: "Details",
  url: "https://explorer.forta.network/alerts?addresses[]=0x12184A71655441EcFae4fd588bFedda0e3105de2",
  icon: fortaIcon,
}
];

const infrastructureProviderNextDatas: ProviderItems[] = [{
  nodeName: "IPFS",
  subTitle: "Gateway",
  buttonText: "Get",
  url: "https://ipfs.wetez.io/",
  icon: IPFSIcon,
  showModal: true,
  modalTitle: "IPFS Public Gateway",
  describe: "IPFS gateway resolves access to any requested IPFS content identifier."
}, {
  nodeName: "Ceramic",
  subTitle: "Gateway",
  buttonText: "Soon",
  url: "",
  type: "Soon",
  icon: CeramicIcon
}
];

const apiProviderDatas: ProviderItems[] = [{
  nodeName: "Ethereum",
  subTitle: "API",
  buttonText: "Get",
  url: "https://rpc.wetez.io/system/apiInfo?chainId=1",
  icon: EthereumIcon
}, {
  nodeName: "Polygon",
  subTitle: "API",
  buttonText: "Get",
  url: "https://rpc.wetez.io/system/apiInfo?chainId=2",
  icon: MaticIcon
},
//  {
//   nodeName: "Cosmos",
//   subTitle: "API",
//   buttonText: "Get",
//   icon: CosmosIcon
// },
{
  nodeName: "Solana",
  subTitle: "API",
  buttonText: "Get",
  url: "https://rpc.wetez.io/system/apiInfo?chainId=3",
  icon: SolanaIcon
}, {
  nodeName: "Arbitrum",
  subTitle: "API",
  url: "https://rpc.wetez.io/system/apiInfo?chainId=4",
  buttonText: "Get",
  icon: ArbitrumIcon
}, {
  nodeName: "HSC",
  subTitle: "API",
  url: "https://rpc.wetez.io/system/apiInfo?chainId=5",
  buttonText: "Get",
  icon: hscIcon
}];

const apiProviderNextDatas: ProviderItems[] = [{
  nodeName: "Cosmos",
  subTitle: "API",
  buttonText: "Get",
  url: "https://rpc.wetez.io/system/apiInfo?chainId=6",
  icon: CosmosIcon
}, {
  nodeName: "Evmos",
  subTitle: "API",
  buttonText: "Get",
  url: "https://rpc.wetez.io/system/apiInfo?chainId=7",
  icon: evmosIcon
}, {
  nodeName: "OKC",
  subTitle: "API",
  buttonText: "Get",
  url: "https://rpc.wetez.io/system/apiInfo?chainId=12",
  icon: icon_Okchain
}, {
  nodeName: "Juno",
  subTitle: "API",
  buttonText: "Get",
  url: "https://rpc.wetez.io/system/apiInfo?chainId=9",
  icon: junoIcon
}, {
  nodeName: "Gravity Bridge",
  subTitle: "API",
  buttonText: "Get",
  url: "https://rpc.wetez.io/system/apiInfo?chainId=11",
  icon: icon_GravityBridge
}];

export const Staking = () => {
  const [displayItems, setDisplayItems] = useState<StakingPoolItemModel[]>([]);
  const { items, info, loading } = useStakingInfo();

  useEffect(() => {
    if (items.length <= 8) {
      setDisplayItems(items);
    } else {
      setDisplayItems(items.slice(0, 5));
    }
  }, [items]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      {/* <Banner /> */}
      <Box style={{
        width: "100%",
        background: "linear-gradient(to right, #D6D2FD, #FBD0DE, #FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF)"
      }}>
        <StakingIntro />
      </Box>



      <div id="poolsAnchor" />

      <Box width="1280px" id="pools">

        {
          loading ? <Box
            height="100px"
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"

          >
            <CircularProgress />
          </Box> : <StakingPools pools={displayItems} />
        }
      </Box>
      <Stack
        alignSelf="stretch"
        alignItems="center"
        sx={{
          backgroundColor: "#1D232A",
        }}
      >
        <Box width="1280px">
          <StakingAnalytics info={info} />
        </Box>
      </Stack>

      <Box width="1280px" id="pools">
        <Provider nextData={apiProviderNextDatas} nextMoreUrl="https://rpc.wetez.io/" nextTitle="Cosmos ecosystems" target="a" datas={apiProviderDatas} moreUrl="https://rpc.wetez.io/" title="API Provider" subTitle="Wetez provides API service to Web3 projects" />
      </Box>
      <Box width="1280px" id="pools">
        <Provider nextData={infrastructureProviderNextDatas} hidNextMore={true} nextMoreUrl="" nextTitle="Decentralized storage gateway" target="_self" datas={infrastructureProviderDatas} moreUrl="/web3" title="Infrastructure Provider" subTitle="Wetez provides infrastructure and service to Web3 projects" />
      </Box>



      <Stack
        alignSelf="stretch"
        alignItems="center"
        sx={{
          backgroundColor: "#1D232A",
        }}
      >
        <Box width="1280px">
          <Web3ToolBuilder />
        </Box>
      </Stack>


      <Box width="1280px">
        <StakingSecurity />
      </Box>
      <Stack
        alignSelf="stretch"
        alignItems="center"
        sx={{
          backgroundColor: "#1D232A",
        }}
      >
        <Box width="1280px">
          <StakingCommunity />
        </Box>
      </Stack>

      {/* <Stack
        alignSelf="stretch"
        alignItems="center"
        sx={{
          backgroundColor: "#191C24",
        }}
      >
        <Box width="1280px">
          <StakingWallet />
        </Box>
      </Stack> */}

      <Box width="1280px">
        <StakingWetezBenefits />
      </Box>
    </Box>
  );
};
